export const cleanUrl = url => {
    return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
};
